import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { UpdateNotice } from "@/components/UpdateNotice";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ROLE_HOME } from "@/lib/api";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Register from "@/pages/Register";
import CustomerDashboard from "@/pages/CustomerDashboard";
import DriverDashboard from "@/pages/DriverDashboard";
import CompanyDashboard from "@/pages/CompanyDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Statement from "@/pages/Statement";
import PosterPage from "@/pages/PosterPage";
import { AuthCallback } from "@/components/GoogleAuth";
import { capturePosterScan } from "@/lib/poster";

capturePosterScan(window.location.search);

const Loader = () => (
  <div className="flex min-h-screen items-center justify-center bg-[#0B192C]">
    <div className="h-10 w-10 animate-spin rounded-full border-4 border-blue-400 border-t-amber-400" />
  </div>
);

const Protected = ({ roles, children }) => {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role)) return <Navigate to={ROLE_HOME[user.role]} replace />;
  return children;
};

const AppRoutes = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Register />} />
            <Route path="/ride" element={<Protected roles={["customer"]}><CustomerDashboard /></Protected>} />
            <Route path="/driver" element={<Protected roles={["driver"]}><DriverDashboard /></Protected>} />
            <Route path="/fleet" element={<Protected roles={["company"]}><CompanyDashboard /></Protected>} />
            <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
            <Route path="/admin/statement/:party/:partyId/:date" element={<Protected roles={["admin"]}><Statement /></Protected>} />
            <Route path="/poster" element={<Protected roles={["admin", "company"]}><PosterPage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  useEffect(() => {
    document.title = "Comfort Taxi · Port Moresby";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        <UpdateNotice />
      </AuthProvider>
    </div>
  );
}

export default App;
